// Contador de tempo decorrido VIVO ("⏱ 3m 42s") — tick de 1s isolado neste
// componente (só ele re-renderiza; a página não). Admin 2026-06-11: o contador
// correndo por segundo é o sinal visível de que a demanda tem atividade.
import { useNowTick } from '@/hooks/useNowTick';

/** "42s" → "3m 42s" → "2h07" → "3d" (segundos só até 1h; depois viram ruído). */
function formatElapsedLive(
  iso: string | null | undefined,
  now = Date.now(),
): string | null {
  if (!iso) return null;
  const t = new Date(iso).getTime();
  if (!Number.isFinite(t)) return null;
  const totalSec = Math.floor(Math.max(0, now - t) / 1000);
  if (totalSec < 60) return `${totalSec}s`;
  const min = Math.floor(totalSec / 60);
  if (min < 60) return `${min}m ${String(totalSec % 60).padStart(2, '0')}s`;
  const h = Math.floor(min / 60);
  const rm = min % 60;
  if (h < 24) return rm > 0 ? `${h}h${String(rm).padStart(2, '0')}` : `${h}h`;
  const d = Math.floor(h / 24);
  return `${d}d`;
}

export function ElapsedClock({
  since,
  className = 'wf-elapsed',
  icon = true,
}: {
  since: string | null | undefined;
  className?: string;
  icon?: boolean;
}) {
  const now = useNowTick(1_000);
  return (
    <span className={className}>
      {icon ? '⏱ ' : ''}
      {formatElapsedLive(since, now) ?? '—'}
    </span>
  );
}
